import React, { useContext, useEffect, createContext } from 'react';

// project-imports
import { initialState as defaultDomainState } from '../reducers/domainReducer';
import { GET_DOMAIN_FAILURE, GET_DOMAIN_SUCCESS } from '../constants/actions';

// third-party
import { useDispatch, useSelector } from 'react-redux';

// Create context
const DomainContext = createContext(defaultDomainState);

export const DomainProvider = (props) => {

    // Reading store data
    const state = useSelector(state => state.domain);
    
    // Reading dispatch from Store
    const dispatch = useDispatch();

    useEffect(() => {
        try {
            // Dispatching the actions on success
            dispatch({ type: GET_DOMAIN_SUCCESS, payload: { coursesDomain: props.value && props.value.coursesDomain ? props.value.coursesDomain : props.value } });
        } catch (error) {
            // Dispatching the actions on error
            dispatch({ type: GET_DOMAIN_FAILURE, payload: error && error.message });
        }
    }, []);
    
    return (
        <DomainContext.Provider value={{ coursesDomain: props.value && props.value.coursesDomain ? props.value.coursesDomain : props.value ? props.value : state.coursesDomain }}>
            {props.children}
        </DomainContext.Provider>
    )
}
export const useDomainContext = () => {
    return useContext(DomainContext)
}
